<template>
    <div>
        <b-card
            :title="titulo"
            :img-src="laImagen"
            img-alt="Image"
            img-top
            tag="article"
            class="mb-2"
        >
            <b-card-text>
                {{ descripcion }}
            </b-card-text>

            <div class="text-right">
                <b-button v-show="botonDetalle=='S'" @click="leerMas" variant="primary">Leer más</b-button>
                <b-button v-show="botonRegresar=='S'" @click="regresar" variant="primary">Regresar</b-button>
            </div>
        </b-card>
    </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
    name: 'Noticia',
    props: {
        idNoticia: {
            type: String,
            default: '0'
        },
        titulo: {
            type: String,
            default: ''
        },
        imagen: String,
        descripcion: {
            type: String,
            default: ''
        },
        botonDetalle: {
            type: String,
            default: 'S'
        },
        botonRegresar: {
            type: String,
            default: 'N'
        }
    },
    data() {
        return {
            variable: ''
        }
    },
    methods: {
        leerMas() {
            this.$router.push(`/detallenoticia/${this.idNoticia}`)
        },
        regresar() {
            this.$router.push(`/noticias`)
        }
    },
    computed: {
        laImagen() {
            if ( ["localhost", "127.0.0.1", ""].includes(window.location.hostname) ) {
                return `${this.urlSandbox}/imagenes/noticias/${this.imagen}`
            } else {
                return `${this.urlProd}/imagenes/noticias/${this.imagen}`
            }
            
        },
        ...mapState(['urlProd']),
        ...mapState(['urlSandbox'])
    }
}
</script>

<style scoped>

</style>